"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogContent = exports.StyledDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("..");
exports.StyledDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    width: 80vw;
    max-width: calc(100vw - 2rem);
    height: 85vh;
    min-width: 0;
    min-height: 0;
    max-height: calc(100vh - 2rem);
  }

  .alert-dialog-title {
    padding: 1rem 1.5rem;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.75rem;
    letter-spacing: 0;
  }

  .create-entity-dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem 1rem;
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
  }

  .create-entity-dialog-title-text {
    flex: 1 1 16rem;
    min-width: 0;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.75rem;
    letter-spacing: 0;
  }

  .alert-dialog-title .MuiTypography-root,
  .create-entity-dialog-title-text .MuiTypography-root {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }

  .create-entity-dialog-title-action {
    flex: 0 1 18rem;
    min-width: min(100%, 14rem);
  }

  @media (max-width: 600px) {
    .create-entity-dialog-title {
      align-items: flex-start;
    }

    .create-entity-dialog-title-text,
    .create-entity-dialog-title-action {
      flex-basis: 100%;
    }
  }

  /* Reset the shared DialogContent padding so Enrich spacing comes only from StyledDialogContent. */
  .alert-dialog-content {
    padding: 0;
  }

  .MuiDialogActions-root {
    justify-content: flex-end;
    padding: 1rem 1.5rem;
  }

  .MuiDialogActions-root .MuiButton-root:last-child {
    margin-left: 0;
    margin-right: 0;
  }
`;
exports.StyledDialogContent = (0, styled_components_1.default)(generic_1.ActionDialogContent) `
  gap: 1rem;
  min-height: 0;
  overflow-y: ${({ $isScrollable }) => ($isScrollable ? 'auto' : 'hidden')};
  padding: 1rem 1.5rem;
`;
